module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"currentPlan":"Ditt nåværende abonnement er {plan}","month":"månedlig","annual":"årlig","free":"gratis for alltid"},"en":{"currentPlan":"Your current subscription plan is {plan}","month":"monthly","annual":"annual","free":"free forever"}}')
  delete Component.options._Ctor
}
